// extracted by mini-css-extract-plugin
export default {"copybutton__button":"copybutton_copybutton__button__FkBJp"};